import styled from 'styled-components';
import {
  mqMediumMin,
  mqLargeMin,
  mqLargeMax,
} from 'styled/tools/media-queries';
import { TypeHeadingTertiary, TypeLabel } from '../Typography';
import { aligns } from '.';

export const Section = styled.section`
  background: var(--fill-primary);
  padding-block: var(--spacing-16);
  padding-inline: var(--spacing-16);

  @media ${mqMediumMin} {
    padding-inline: var(--spacing-24);
  }

  @media ${mqLargeMin} {
    padding-block: var(--spacing-80);
    padding-inline: var(--spacing-32);
  }
`;

export const Frame = styled.div<{ align: aligns }>`
  background-color: var(--fill-brand);
  background-size: cover;
  aspect-ratio: 1 / 1;
  border-radius: var(--radius-md);
  align-items: center;
  justify-content: ${(props) => props.align || 'center'};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  grid-column: auto / span 6;
  padding: var(--spacing-48) 128px;
  width: 100%;

  ${(props) =>
    props.align == 'end' &&
    `
    justify-content: end;

    &:has(.eyebrow) {
        justify-content: space-between;
    }
  `}

  @media ${mqLargeMax} {
    padding: var(--spacing-24) var(--spacing-56);
    grid-column: 1 / -1;
  }

  & > picture,
  & img,
  & > video {
    block-size: 100%;
    inline-size: 100%;
    object-fit: cover;
  }
`;

export const BookendContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  & > * + * {
    margin-top: var(--spacing-24);
  }
`;

export const Eyebrow = styled(TypeLabel)<{ align: aligns }>`
  color: var(--fill-primary);
  align-self: center;
  ${(props) =>
    props.align == 'center' &&
    `
      transform-origin: 0 0;
    transform: rotate(90deg);
      position: absolute;
      top: 33%;
      left: var(--spacing-32);
    `}
`;

export const BookendWordWrapper = styled(TypeHeadingTertiary)`
  position: relative;

  &:before,
  &:after {
    position: absolute;
    top: 0;
  }

  &:before {
    content: '【';
    left: -44px;
  }

  &:after {
    content: '】';
    right: 60px;
    transition: all 0.5s linear;
  }

  &.is-visible:after {
    right: -44px;
  }
`;

export const BookendWord = styled(TypeHeadingTertiary)``;
export const BookendTitle = styled(TypeHeadingTertiary)`
  color: var(--fill-primary);
  font-feature-settings: 'ss05' on;
  display: flex;
  gap: var(--spacing-32);

  &[data-pill]:before {
    content: attr(data-pill);
    color: var(--fill-primary);
    font-family: var(--ff);
    font-size: var(--font-size-350);
    font-weight: 500;
    text-transform: uppercase;
    border-radius: var(--radius-full);
    border: 1.5px solid currentColor;
    padding-block: var(--spacing-8);
    padding-inline: 12px;
    vertical-align: middle;
    display: inline-block;
    margin-right: var(--spacing-8);
    margin-bottom: var(--spacing-8);
  }
`;
